import React from "react";
import MuiTextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { getCssVariableHardcoded } from "../../util/functions/getCssVariable";

const primaryColor = getCssVariableHardcoded("--wnp-color-primary");
const secondaryLightColor = getCssVariableHardcoded("--wnp-color-secondary-light");
const fontFamily = getCssVariableHardcoded("--wnp-font-body-regular");

const StyledMuiTextField = styled(MuiTextField)({
    "& label.Mui-focused": {
        color: primaryColor,
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: primaryColor,
    },
    "& .MuiInputLabel-asterisk": {
        display: "none",
    },
    "& .MuiOutlinedInput-root": {
        fontFamily: fontFamily,
        "& fieldset": {
            borderColor: secondaryLightColor
        },
        "&:hover fieldset": {
            borderColor: primaryColor,
        },
        "&.Mui-focused fieldset": {
            borderColor: primaryColor,
        },
        height: "var(--textfield-height, auto)",
    },
    "& .MuiInputLabel-root": {
        fontFamily: fontFamily,
        transform: "var(--textfield-label-transform, translate(14px, 16px) scale(1))",
        "&.Mui-focused, &.MuiFormLabel-filled, &.MuiInputLabel-shrink": {
            transform: "var(--textfield-label-focused-transform, translate(14px, -9px) scale(0.75))",
        }
    },
})

const TextField = ({ ...custom }) => {
    return (
        <StyledMuiTextField
            variant="outlined"
            {...custom}
        />
    )
}

export default TextField;
